import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import EllipsisIcon from '@wix/da-ds/pkg/Icons/Ellipsis';
import IconButtonWithContextMenu from '@wix/da-ds/pkg/Dropdown/Preset/IconButtonWithContextMenu';
import TierCreatorReduxModule from '../redux/creator/ModuleLoadable';
import TierConsumerReduxModule from '../redux/consumer/ModuleLoadable';
import { useTierContextMenuItems } from './hooks';
import DiscordModuleLoader from '../../Discord/redux/ModuleLoader';
const MoreActionsButton = (_param)=>{
    var { isOwner, deviation, className, studioOrdering = false, afterActionUrl } = _param, rest = _object_without_properties(_param, [
        "isOwner",
        "deviation",
        "className",
        "studioOrdering",
        "afterActionUrl"
    ]);
    const { t } = useTranslation();
    const [hasMenuBeenOpened, setHasMenuBeenOpened] = useState(false);
    const items = useTierContextMenuItems(deviation, isOwner, studioOrdering, afterActionUrl);
    const handleInitialOpen = useCallback(()=>{
        setHasMenuBeenOpened(true);
    }, []);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(IconButtonWithContextMenu, _object_spread({
        icon: EllipsisIcon,
        items: items,
        className: className,
        onClick: handleInitialOpen,
        "aria-label": t('common.moreActions')
    }, rest)), // Load redux after the menu has been opened to prevent any page load performance impact
    hasMenuBeenOpened && (isOwner ? /*#__PURE__*/ React.createElement(TierCreatorReduxModule, null) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(TierConsumerReduxModule, null), /*#__PURE__*/ React.createElement(DiscordModuleLoader, null))));
};
MoreActionsButton.displayName = 'MoreActionsButton';
export default MoreActionsButton;

//# sourceMappingURL=MoreActionsButton.js.map